// ***** Interfaces, Types and imports *****
import messageSound from "@assets/sounds/llamada_SPDP_mensaje.mp3";
import incomingCallSound from "@assets/sounds/llamada_SPDP_incoming_call.mp3";
import initCallSound from "@assets/sounds/llamada_SPDP_llamando.mp3";

export type SoundKind = "message" | "incomingCall" | "initCall";

const SOURCES: Record<SoundKind, string> = {
    message: messageSound,
    incomingCall: incomingCallSound,
    initCall: initCallSound,
};

const LOOPED: Record<SoundKind, boolean> = {
    message: false,
    incomingCall: true,
    initCall: true,
};

/**
 * One shared audio element per sound, created the first time it is played.
 * The imports above only resolve to a URL, and `preload = "none"` keeps the
 * browser from fetching the file until something actually calls `playSound`.
 */
const cache: Partial<Record<SoundKind, HTMLAudioElement>> = {};

const getAudio = (kind: SoundKind): HTMLAudioElement => {
    let audio = cache[kind];

    if (!audio) {
        audio = new Audio(SOURCES[kind]);
        audio.preload = "none";
        audio.loop = LOOPED[kind];
        cache[kind] = audio;
    }

    return audio;
};

export const playSound = (kind: SoundKind) => {
    const audio = getAudio(kind);
    audio.currentTime = 0;
    // play() rejects when the browser blocks autoplay before any user gesture
    audio.play().catch((error) => console.debug("playSound", kind, error));
};

export const stopSound = (kind: SoundKind) => {
    const audio = cache[kind];

    if (!audio) return;

    audio.pause();
    audio.currentTime = 0;
};
